var map = {
	"./theme2/battery-red.png": "/nil",
	"./theme2/battery.png": "Tpp1",
	"./theme2/battery/battery-0.png": "ktcV",
	"./theme2/battery/battery-01.png": "898l",
	"./theme2/battery/battery-02.png": "W9Tl",
	"./theme2/battery/battery-03.png": "ql6+",
	"./theme2/battery/battery-04.png": "EK2M",
	"./theme2/battery/battery-1.png": "JXir",
	"./theme2/battery/battery-2.png": "IT5H",
	"./theme2/battery/battery-3.png": "brhG",
	"./theme2/battery/battery-4.png": "TLgF",
	"./theme2/battery/battery-blue.png": "7OVN",
	"./theme2/battery/battery-no.png": "eQye",
	"./theme2/battery/battery-red.png": "ErnX",
	"./theme2/battery/battery.png": "7Ec6",
	"./theme2/battery2.png": "PHxc",
	"./theme2/bms/dianchi-alarm.png": "NYLw",
	"./theme2/bms/dianchi-normal.png": "RnlC",
	"./theme2/cliupdata.png": "x9TV",
	"./theme2/code.png": "cMKc",
	"./theme2/column.png": "UIPR",
	"./theme2/dianchi.png": "IfI9",
	"./theme2/dropimg.png": "YC/N",
	"./theme2/img2.png": "nPU5",
	"./theme2/lease1.png": "uTSt",
	"./theme2/lease2.png": "nphV",
	"./theme2/lease3.png": "ZeUi",
	"./theme2/lease4.png": "T8vt",
	"./theme2/notice.png": "otZL",
	"./theme2/order1.png": "8MyB",
	"./theme2/order2.png": "Lvrr",
	"./theme2/order3.png": "Gra7",
	"./theme2/order4.png": "OMb1",
	"./theme2/push.png": "pOap",
	"./theme2/remarks.png": "paXB",
	"./theme2/totalBattery/1014.png": "KL9/",
	"./theme2/totalBattery/1015.png": "7pC0",
	"./theme2/totalBattery/1016.png": "uPiL",
	"./theme2/totalBattery/1017.png": "sU7m",
	"./theme2/totalBattery/1018.png": "WbBu",
	"./theme2/totalBattery/1019.png": "6ynY",
	"./theme2/totalBattery/1020.png": "TQx+",
	"./theme2/totalBattery/1021.png": "aXKW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "y1cB";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/theme2.*$
// module id = y1cB
// module chunks = 78